import { render, staticRenderFns } from "./RestrictedAreaEditor.vue?vue&type=template&id=f68ecb6c&scoped=true"
import script from "./RestrictedAreaEditor.vue?vue&type=script&lang=js"
export * from "./RestrictedAreaEditor.vue?vue&type=script&lang=js"
import style0 from "./RestrictedAreaEditor.vue?vue&type=style&index=0&id=f68ecb6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68ecb6c",
  null
  
)

export default component.exports